import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { slideInDownAnimation } from '../../../app/app.animation';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import * as fromFormStatus from '../../../screens/form-status/state/form-status.selectors';
import * as FormStatusAction from '../../../screens/form-status/state/form-status.actions';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AngularMaterialService, LGEDataService } from 'src/commons';
@Component({
    selector: 'form-status-table-component',
    templateUrl: 'form-status-table-component.html',
    styleUrls: ['form-status-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStatusTableTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() data: any[];
    @Input() displayedColumns: any[];
    @Input() tableType: string;
    @Input() formType: string;

    emailTemplateList = [];
    isNotSystemTemplateList = [];
    isReadOnlyList = ['APPROVED', 'PENDING APPROVAL', 'REJECTION', 'SUBMIT', 'WITHDRAWN', 'OUTSTANDING TASK'];
    isReadOnlyData = [{ emailTemplateName: 'APPROVED' }, { emailTemplateName: 'PENDING APPROVAL' }, { emailTemplateName: 'REJECTION' }, { emailTemplateName: 'SUBMIT' }, { emailTemplateName: 'WITHDRAWN' }, { emailTemplateName: 'OUTSTANDING TASK' }];
    toAddList = [];
    ccList = [];
    datePipe = new DatePipe('en-US');

    public dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);

    public confirm: any;
    isAllChecked: boolean = false;
    isIndeterminate: boolean = false;
    localData = [];

    constructor(
        private store: Store<fromFormStatus.State>,
        private ref: ChangeDetectorRef,
        private ams: AngularMaterialService,
        private _dataService: LGEDataService,
        private router: Router,
    ) {
    }
    public ngOnInit() {
        setTimeout(() => {
            this.localData = this.data;
            this.buildDataSource(this.localData);
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            setTimeout(() => {
                this.localData = changes['data'].currentValue;
                this.buildDataSource(this.localData);
                this.selection.clear();
            });
        }
    }

    buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);

        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'orgInfoName': return item.orgInfoName.toLowerCase();
                case 'formName': return item.formName.toLowerCase();
                case 'requestNo': return +item.requestNo.substring(2);
                case 'status': return item.status.toLowerCase();
                case 'OeBSStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                case 'dateRequest': return new Date(item.dateRequest);
                default: return item[property];
            }
        };

        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'OrgInfo':
                        return currentTerm + data.orgInfoName;
                    case 'FormCCLogInfo':
                        return currentTerm + data.FormCCLogInfo.empName
                            + data.FormCCLogInfo.title
                            + data.FormCCLogInfo.comment;
                    case 'effdt':
                        const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy');
                        return currentTerm + newDate.toString();
                    default:
                        return currentTerm + data[key];
                }
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.clearToggle();
    }

    isAllSelected() {
        let isAll = false;
        isAll = this.localData !== undefined ? this.localData.length === this.selection.selected.length : false;
        this.isAllChecked = this.selection.hasValue() && isAll;
        this.isIndeterminate = this.selection.hasValue() && !isAll;
    }

    masterToggle(event) {
        if (this.isAllChecked) {
            this.clearToggle();
        } else {
            this.dataSource.filteredData.forEach(row => this.selection.select(row));
        }
        this.isAllSelected();
    }

    requestChecked(row) {
        this.selection.toggle(row);
        this.isAllSelected();
    }

    clearToggle() {
        this.selection.clear();
        this.isAllSelected();
    }

    GetEmailTemplates(): Promise<any> {
        return new Promise((resolve) => {
            this._dataService.GetEmailTemplates().subscribe(
                {
                    next: data => {
                        this.emailTemplateList = data.map((obj) => {
                            if (this.isReadOnlyList.indexOf(obj.emailTemplateName) > -1) {
                                obj.systemTemplate = true;
                            } else {
                                obj.systemTemplate = false;
                            }
                            return obj;
                        });
                        resolve('Loaded');
                    }, error: error => {
                        resolve('Error');
                        this.ams.closeDialog();
                        this.ams.showAlert('Error!', `Resource not available! \n ${error.message}`);
                        this.ref.markForCheck();
                    }
                }
            )
            this.ref.markForCheck();
        });
    }

    onComposeEmail() {
        let selectedData = this.selection.selected.filter(f => f.emailDate == '' || f.emailDate == null);
        this.ams.showLoader('Loading...');
        this.GetEmailTemplates().then((status) => {
            if (status === 'Loaded') {
                this._dataService.GetUsersGroupForRole('BASE').subscribe({
                    next: data => {
                        this.ccList = _.sortBy(data.map(cc => cc.email));
                        this.ams.closeDialog();

                        this.isNotSystemTemplateList = _.differenceBy(this.emailTemplateList, this.isReadOnlyData, 'emailTemplateName');

                        if (this.emailTemplateList.length > 0) {
                            this.ams.showComposeAwardDeclineEmail('Compose Award/Decline Email', 'Compose Email',
                                this.isNotSystemTemplateList,
                                this.toAddList,
                                this.ccList);
                            this.ams.composeEmail.afterClosed().subscribe(result => {
                                if (result) {
                                    const obj: any = {};
                                    obj.requestList = selectedData;
                                    obj.email = result;
                                    this.store.dispatch(new FormStatusAction.ComposeEmail(obj));
                                }
                            });
                        }
                        this.ref.markForCheck();
                    }, 
                    error: error => {
                        this.ams.closeDialog();
                        this.ams.showAlert('Error!', error.message);
                        this.ref.markForCheck();
                    }
                })
            }
        });
    }

    onCloseRequest() {
        this.store.dispatch(new FormStatusAction.CloseRequest(this.selection.selected))
    }

    public getStatusClass(status): string {
        const possibleStatus = ['Submitted', 'Pending', 'Draft', 'Approved', 'Pending Approval', 'Pending  VP, CR & CA Approval',
            'Sent To Foundation Trustee', 'Rejected', 'Sent To Oracle', 'Waiting For Oracle', 'Withdrawn', 'Paid Credit', 'Check Cashed', 'Check Issued', 'Check Voided', 'Check Cleared', 'Cancelled', 'Reassign to CI', 'Pending CR&CA Approval', 'Pending CIT Review', 'Pending Foundation Board of Directors Review', 'Pending CCC Review'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
        switch (row.requestNo.substring(0, 2)) {
            case 'PP':
                this.router.navigate([`charity-forms/plant-planet/${row.formID}`]);
                break;
            case 'CG':
                this.router.navigate([`charity-forms/community-grant/${row.formID}`]);
                break;
            case 'ES':
                this.router.navigate([`charity-forms/event-sponsorship/${row.formID}`]);
                break;
            case 'FO':
                this.router.navigate([`charity-forms/foundation/${row.formID}`]);
                break;
            case 'CI':
                this.router.navigate([`charity-forms/community-investment/${row.formID}`]);
                break;
        }
    }

    public isVisible(row: any): boolean {
        if (this.tableType == "Email") {
            if (row.emailDate === "" || row.emailDate === null) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

}
